export default {
  translation: {
    'Welcome!': 'Приветствуем!'
  }
};
